module.exports = __webpack_public_path__ + "static/assets/f29d0742a5c2a4162d0da7ca530b3123.png";